import styled from 'styled-components'
import { Col, Row } from 'antd'

// Main container
export const DiagnosisListWrapper = styled.div`
  padding: 12px;
  border-radius: 8px;
`

// Filter Layout - Inline style matching CandidateList
export const FilterInlineContainer = styled.div`
  padding: 24px 0;
  margin-bottom: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  
  @media (max-width: 1200px) {
    padding: 20px 0;
  }
`

export const FilterGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  padding: 0 24px;

  @media (max-width: 768px) {
    gap: 16px;
    padding: 0 16px;
  }
`

export const FilterGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  
  .ant-form-item {
    margin-bottom: 0;
  }
  
  .ant-select,
  .ant-tree-select {
    border-radius: 8px;
    border: 1px solid #d1d5db;
    transition: all 0.2s ease;
    min-width: 160px;
    max-width: 180px;
    
    &:hover {
      border-color: #3249d7;
      box-shadow: 0 0 0 2px rgba(50, 73, 215, 0.1);
    }
    
    &:focus,
    &.ant-select-focused,
    &.ant-tree-select-focused {
      border-color: #3249d7;
      box-shadow: 0 0 0 3px rgba(50, 73, 215, 0.15);
    }
  }
`

export const FilterLabel = styled.label`
  font-weight: 600;
  color: #374151;
  font-size: 13px;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`

export const StyledFormItem = styled.div`
  .ant-select {
    width: 100%;
  }
`

// Header and Layout
export const HeaderFullWidth = styled.div`
  width: 100%;
`

export const FilterSection = styled.div`
  margin-bottom: 0px;
`

// Candidate/Student Info - matching CandidateList
export const CandidateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CandidateName = styled.span`
  font-weight: 600;
  color: #3249d7;
  display: block;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const CandidateId = styled.span`
  font-size: 12px;
  color: #6b7280;
  word-break: break-all;
`

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #374151;
  word-break: break-word;
`

// Level Badges
export const LevelBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 13px;
  background: ${props => {
    const level = props.level?.toUpperCase()
    if (['C2-ADVANCED', 'C1-ADVANCED', 'ADVANCED'].includes(level)) return '#dcfce7'
    if (['B2-UPPER-INTERMEDIATE', 'B1-INTERMEDIATE', 'COMPETENT', 'INTERMEDIATE'].includes(level)) return '#dbeafe'
    if (['A2-BEGINNER', 'A1-BEGINNER', 'LEARNER', 'BEGINNER'].includes(level)) return '#fef3c7'
    return '#f3f4f6'
  }};
  color: ${props => {
    const level = props.level?.toUpperCase()
    if (['C2-ADVANCED', 'C1-ADVANCED', 'ADVANCED'].includes(level)) return '#166534'
    if (['B2-UPPER-INTERMEDIATE', 'B1-INTERMEDIATE', 'COMPETENT', 'INTERMEDIATE'].includes(level)) return '#1d4ed8'
    if (['A2-BEGINNER', 'A1-BEGINNER', 'LEARNER', 'BEGINNER'].includes(level)) return '#92400e'
    return '#374151'
  }};
`

// Score display
export const ScoreBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ScoreBarTrack = styled.div`
  width: 60px;
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
`

export const ScoreBarFill = styled.div`
  height: 100%;
  width: ${props => Math.min(100, props.percentage || 0)}%;
  background: ${props => {
    const pct = props.percentage || 0
    if (pct >= 70) return '#22c55e'
    if (pct >= 40) return '#3b82f6'
    return '#f59e0b'
  }};
  border-radius: 3px;
`

export const ScoreValue = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: #374151;
  min-width: 45px;
`

// Stats Cards
export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`

export const StatCard = styled.div`
  flex: 1;
  padding: 16px 20px;
  background: ${props => props.color || '#f9fafb'};
  border-radius: 12px;
  text-align: center;
`

export const StatLabel = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
`

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
`

// Chart Container
export const ChartContainer = styled.div`
  margin-bottom: 24px;
`

export const ChartCard = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
`

export const ChartTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
`

// No data state
export const NoData = styled.div`
  text-align: center;
  padding: 40px;
  color: #6b7280;
`

// Table wrapper
export const TableWrapper = styled.div`
  margin-top: 16px;
`
